
import React from 'react';
import firebase from 'firebase';



const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);

var status = firestore.collection("systemStatus").doc("status");



export default class PiStatus extends React.Component {
    state = {
        piStatus : "",
        piLastupdated : "",
    }


    getDoc = status.get()
        .then(doc => {
            if (!doc.exists) {
                console.log('No status document!');
            } else {
                console.log('Document data:', doc.data());
                this.setState({piStatus : doc.data().piStatus})
                this.setState({piLastupdated :  doc.data().piEpoch})
            }
        })
        .catch(err => {
            console.log('Error getting document', err);
        });

    render(){
        return (
            <div>
            <p>Pi Status: {this.state.piStatus} . Last checked : {this.state.piLastupdated} </p>      
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Component/PiStatus.js